import React, { useRef, useState } from "react";
import { Container, Row, Col, Button, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import LetterHeader from "./LetterHeader";

export default function AdmissionCard({ student }) {
  const printRef = useRef();

  const auth = useSelector((state) => state.authentication);
  const { branchData } = auth;

  const [formData, setFormData] = useState({
    name:
      [student?.firstName, student?.middleName, student?.lastName]
        .filter(Boolean)
        .join(" ") || "",
    admitNumber: student?.studentId || "",
    course: student?.selectedCourse || "",
    academicYear: student?.academicYear || "",
    date: new Date().toLocaleDateString("en-IN"),
    place: "Bangalore",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const win = window.open("", "", "width=900,height=700");

    win.document.write(`
      <html>
        <head>
          <title>Admission Card (A5)</title>
          <link
            rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
          />
          <style>
            @page {
              size: A5 landscape;
              margin: 10mm;
            }
            @media print {
              body {
                font-family: 'Times New Roman', Times, serif;
                padding: 10px;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              .print-container { line-height: 1.6; }
            }
            body {
              font-family: 'Times New Roman', Times, serif;
              padding: 20px;
            }
            .header {
              text-align: center;
              margin-bottom: 15px;
            }
            .subtitle {
              font-weight: bold;
              font-size: 16px;
              margin-top: 15px;
              margin-bottom: 15px;
              text-decoration: underline;
            }
            .field-row {
              margin: 14px 0;
              font-size: 14px;
            }
            .label {
              display: inline-block;
              width: 160px;
              font-weight: bold;
            }
            .line {
              display: inline-block;
              border-bottom: 1px dotted #000;
              width: 65%;
              padding-left: 10px;
            }
            .footer {
              margin-top: 40px;
            }
            .left {
              float: left;
            }
            .right {
              float: right;
              font-weight: bold;
            }
            .clear {
              clear: both;
            }
          </style>
        </head>
        <body>
          <div class="print-container">${content}</div>
        </body>
      </html>
    `);

    win.document.close();
    win.focus();
    setTimeout(() => {
      win.print();
    }, 500);
  };

  return (
    <Container className="py-4">
      {/* FORM CONTROL PANEL */}
      <Form className="mb-4">
        <Row className="mb-2">
          <Col>
            <Form.Label className="small text-muted">Student Name</Form.Label>
            <Form.Control
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
          </Col>
          <Col>
            <Form.Label className="small text-muted">Admit Number</Form.Label>
            <Form.Control
              name="admitNumber"
              value={formData.admitNumber}
              onChange={handleChange}
            />
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Label className="small text-muted">Course</Form.Label>
            <Form.Control
              name="course"
              value={formData.course}
              onChange={handleChange}
            />
          </Col>
          <Col>
            <Form.Label className="small text-muted">Academic Year</Form.Label>
            <Form.Control
              name="academicYear"
              value={formData.academicYear}
              onChange={handleChange}
            />
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Form.Label className="small text-muted">Date</Form.Label>
            <Form.Control
              name="date"
              value={formData.date}
              onChange={handleChange}
            />
          </Col>
          <Col>
            <Form.Label className="small text-muted">Place</Form.Label>
            <Form.Control
              name="place"
              value={formData.place}
              onChange={handleChange}
            />
          </Col>
        </Row>
      </Form>

      {/* ACTION PRINT BUTTON */}
      <div className="text-end mt-4 mb-3">
        <Button variant="primary" onClick={handlePrint}>
          Print Admission Card (A5)
        </Button>
      </div>

      {/* PRINTABLE A5 CARD CONTAINER */}
      <div
        ref={printRef}
        style={{ padding: 25, border: "1px solid #000" }}
        className="print-container bg-white"
      >
        <div className="header text-center">
          <LetterHeader
            branchData={branchData}
            useOldAddress={false}
            badgeText=""
            badgeBg="primary"
            paperSize="A5"
          />

          <div className="subtitle">ADMISSION CARD</div>
        </div>

        <div className="field-row">
          <span className="label">NAME</span> :
          <span className="line">{formData.name}</span>
        </div>

        <div className="field-row">
          <span className="label">ADMIT NUMBER</span> :
          <span className="line">{formData.admitNumber}</span>
        </div>

        <div className="field-row">
          <span className="label">COURSE</span> :
          <span className="line">{formData.course}</span>
        </div>

        <div className="field-row">
          <span className="label">ACADEMIC YEAR</span> :
          <span className="line">{formData.academicYear}</span>
        </div>

        <div className="footer">
          <div className="left">
            <div>Date : {formData.date}</div>
            <div>Place : {formData.place}</div>
          </div>

          <div className="right">ADMIN</div>

          <div className="clear"></div>
        </div>
      </div>
    </Container>
  );
}